/* src/app/shared/components/alert/alert.component.scss */
.actions {
  display: flex;
  justify-content: center;
}
/*# sourceMappingURL=alert.component.css.map */
